export default __webpack_public_path__ + "images/Coronal_View_of_the_Spine_dark.5f3025bf033f9ac2088e32ab84ff1a3b.png";